module.exports = __webpack_public_path__ + "img/tires.464931e7.svg";